<template>
  <div id="serviceTab">
    <navmenu></navmenu>
    <div class="content">
      <div class="top">
        <div class="title">
          <span>Customer service Always ready to help</span>
        </div>
        <p style="font-weight: bold; font-size: 20px; margin-top: 20px">
          Contact us Monday to Friday
        </p>
        <p class="time">8:00-18:00</p>
        <p class="amountText">Maximum loan amount</p>
        <div class="phpamount">
          <img src="@/assets/phpAmount.png" alt="" />
        </div>
        <p style="color: #3d16d2; font-size: 20px">Low interest</p>
        <div class="info">
          <ul>
            <li>
              <img src="@/assets/tel.png" alt="" />
              <p>+63 9065241087</p>
            </li>
            <li>
              <img style="height: 15px" src="@/assets/email.png" alt="" />
              <p>info@excellentrealending.com</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <img class="logo" src="@/assets/logo.png" alt="" />
          <p style="font-size: 18px">Providing reliable financial services</p>
          <div class="title">
            <p>Address</p>
            <p style="margin-left: 280px">Need help</p>
          </div>
          <div style="margin-top:15px">
            <img
              @click="openAddress"
              style="width: 38px; height: 38px; cursor: pointer; display: block"
              src="@/assets/addressIcon.png"
              alt=""
            />
          </div>
          <div class="about">
            <p style="margin-right: 110px">
              <span style="white-space: pre">Address:</span>
              <br />
              2806 Trade and Financial Tower， Lane Q，Bonifacio Global City，
              Taguig City，Philippines
            </p>
            <p>
              Contact us
              <br />
              Monday to Friday 8:00-18:00
              <br />
              Email: info@excellentrealending.com
              <br />
              Call center: +63 9065241087
            </p>
          </div>
          <p
            style="
              color: #fff;
              font-size: 14px;
              margin-top: 46px;
              font-family: PingFangSC, PingFang SC;
            "
          >
            Support belongs to EXCELLENT ERA LENDING SERVICE CORP.
          </p>
        </div>
        <div class="right">
          <p>Download the app now!</p>
          <div class="rightImg">
            <img style="margin-bottom: 35px" src="@/assets/google.png" alt="" />
            <img src="@/assets/appStore.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'serviceTab',
  data () {
    return {}
  },
  methods: {
    openAddress () {
      window.open('https://maps.app.goo.gl/s8Q5Z3yHPxDF5baK8')
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  background-image: url("~@/assets/eelendingBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 230px;
  padding-top: 65px;
  .top {
    background-image: url("~@/assets/peopleBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: auto;
    width: 1300px;
    padding: 70px 0 70px 130px;
    text-align: left;
    color: #3d16d2;
    font-family: Poppins, Poppins;
    .title {
      line-height: 56px;
      font-size: 50px;
      font-weight: bold;
      width: 540px;
    }
    .time {
      color: #cff202;
      font-weight: bold;
      font-size: 24px;
      background-color: #5931f4;
      padding: 13px 87px;
      width: 318px;
      border-radius: 30px;
      margin-top: 12px;
    }
    .amountText {
      font-size: 20px;
      color: #4119d4;
      font-weight: 400;
      margin-top: 40px;
    }
    .phpamount {
      margin-bottom: 30px;
      img {
        display: block;
        width: 338px;
        height: 64px;
      }
    }
    .info {
      color: #cff202;
      font-size: 14px;
      background: #5931f4;
      border-radius: 25px;
      padding: 14px 45px;
      width: 530px;
      margin-top: 60px;
      ul {
        display: flex;
        justify-content: space-between;
      }
      li {
        width: 50%;
        display: flex;
        align-items: center;
      }
      img {
        width: 20px;
        height: 15px;
        margin-right: 5px;
      }
    }
  }
  .bottom {
    background-image: url("~@/assets/footerBg.png");
    background-size: 100% 100%;
    width: 1310px;
    margin: auto;
    margin-top: 110px;
    text-align: left;
    color: #cff202;
    padding: 38px 52px 38px 120px;
    display: flex;
    justify-content: space-between;
    .left {
      font-family: Poppins, Poppins;
      .logo {
        background: #ffffff;
        border-radius: 37px;
        padding: 7px 0px 7px 10px;
        width: 256px;
        height: 65px;
      }
      .title {
        margin-top: 37px;
        color: #fff;
        display: flex;
        width: 660px;
        border-bottom: 1px solid #fff;
        font-size: 24px;
        padding-bottom: 15px;
      }
      .about {
        font-size: 14px;
        margin-top: 5px;
        display: flex;
        p {
          width: 270px;
          line-height: 26px;
        }
      }
    }
    .right {
      margin-top: 119px;
      font-family: Poppins, Poppins;
      font-weight: bold;
      color: #cff202;
      font-size: 30px;
      width: 375px;
      margin-right: -40px;
      .rightImg {
        margin-top: 89px;
        text-align: center;
      }
      img {
        width: 222px;
        height: 65px;
      }
    }
  }
}
</style>
